<template>
  <div>
    <div class="text-right">
      <v-btn icon @click="$emit('close')">
        <v-icon> close </v-icon>
      </v-btn>
      <div class="text-left">
        <v-btn @click="--step" text v-if="step !== 1"
          ><v-icon>mdi-chevron-left</v-icon>back</v-btn
        >
      </div>
    </div>
    <div class="pa-5 pt-0">
      <div v-if="step == 1">
        <v-card
          @click="selectType(item, k)"
          :key="k"
          class="pa-2 my-3"
          v-for="(item, k) in type"
        >
          <span style="font-weight: 600">
            {{ item.name }}
          </span>
        </v-card>
      </div>
      <div
        v-if="step == 2"
        style="border: 1px solid #d6d6d6; border-radius: 5px"
      >
        <div class="text-center py-2">{{ type[selectedTypeKey].name }}</div>
        <v-divider></v-divider>
        <v-simple-table height="300px">
          <template v-slot:default>
            <tbody style="border: 1px solid black">
              <tr v-for="(item, i) in type[selectedTypeKey].items" :key="i">
                <td @click="selectItem(item, i)">
                  {{ typeof item === "object" ? item.name : item }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <div v-if="step == 3">
        <div
          v-if="typeof currentJob === 'object'"
          style="border: 1px solid #d6d6d6; border-radius: 5px"
        >
          <div class="text-center py-2">
            {{ currentType.name }} - {{ currentJob.name }}
          </div>
          <v-divider></v-divider>
          <v-simple-table height="300px">
            <template v-slot:default>
              <tbody style="border: 1px solid black">
                <tr v-for="(item, i) in currentJob.items" :key="i">
                  <td @click="selectLocation(item, i)">{{ item }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div v-else>
          <div>กรุณากรอก ลักษณะงานที่สนใจ</div>
          <ValidationObserver ref="jobobserver">
            <div class="greyinput">
              <ValidationProvider
                :name="'อื่นๆ'"
                :rules="'required'"
                key="etc"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  solo
                  dense
                  v-model="input.etc"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </ValidationObserver>
        </div>
        <div class="text-center">
          <v-btn @click="onSave" class="px-10" depressed color="primary"
            >ยืนยัน</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    jobList: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  data() {
    return {
      step: 1,
      selectedTypeKey: 0,
      selectedJobKey: 0,
      selectedLocationKey: 0,
      input: { etc: "" },
      type: [],
    };
  },
  computed: {
    currentType() {
      return this.type[this.selectedTypeKey];
    },
    currentJob() {
      if (!this.currentType) return "";
      return this.currentType.items[this.selectedJobKey];
    },
    currentLocation() {
      if (!this.currentJob) return "";
      return this.currentJob.items[this.selectedLocationKey];
    },
  },
  methods: {
    async onSave() {
       if (await this.$refs.jobobserver.validate()) {
        this.$emit("onSave", {
          type: this.currentType.name,
          job: this.input.etc,
        });
      }
    },
    selectType(item, k) {
      this.selectedType = item.name;
      this.selectedTypeKey = k;
      this.step = 2;
    },
    selectItem(item, index) {
      this.selectedJobKey = index;
      if (item == "etc." || typeof item === "object") {
        this.step = 3;
      } else {
        this.$swal
          .fire({
            text: "ยืนยันการเลือก ?",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            confirmButtonText: "ยืนยัน",
          })
          .then((result) => {
            if (result.value) {
              this.$emit("onSave", {
                type: this.currentType.name,
                job: item,
              });
            }
          });
      }
    },
    selectLocation(item, index) {
      this.selectedLocationKey = index;
      this.$swal
        .fire({
          text: "ยืนยันการเลือก ?",
          showCancelButton: true,
          cancelButtonText: "ยกเลิก",
          confirmButtonText: "ยืนยัน",
        })
        .then((result) => {
          if (result.value) {
            this.$emit("onSave", {
              type: this.currentType.name,
              job: this.currentJob.name,
              location: this.currentLocation,
            });
          }
        });
    },
  },
  mounted() {
      this.type = this.jobList; 
  },
};
</script>

<style lang="scss" scoped></style>
